<div class="viewport">
    <div class="strip" [style.transform]="isDetailVisible() ? 'translateX(-100%)' : 'translateX(0)'">
        
        <div class="slide">
            <spike-base-page [breadcrumbItems]="breadcrumbItems()" [title]="title()" [subTitle]="subTitle()">
                <div header>
                    <spike-positions-filters-form [workflowState]="workflowState()" [(searchFilter)]="searchFilter"></spike-positions-filters-form>
                </div>

                <div>
                    @if(entityList.hasValue() && entityList.value().list.length > 0){
                        <div class="font-bold text-xl mb-1">Elenco risultati {{entityList.value().list.length}}</div>
                        <div class="spike-table-card">
                            <spike-positions-table 
                                [items]="entityList.value().list" 
                                [(sorting)]="sorting"
                                (onSelect)="selectedItem.set($event)" 
                                [workflowState]="workflowState()">
                            </spike-positions-table>
                            <p-paginator 
                                (onPageChange)="onPageChange($event)" 
                                [first]="pagination().first" 
                                [rows]="pagination().rows" 
                                [totalRecords]="entityList.value().totalCount" 
                                [rowsPerPageOptions]="this.pagination().rowsPerPageOptions" />
                        </div>
                    } @else {
                        <spike-no-result></spike-no-result>
                    }
                </div>
            </spike-base-page>
        </div>

        <div class="slide">
            @if(selectedItem()) {
                <spike-order-page 
                    [orderId]="selectedItem()!.orderId" 
                    [orderPage]="1"
                    [positionStatePage]="workflowState().id ? workflowState().id!-1 :0"
                    [selectedPositionId]="selectedItem()!.positionId"
                    (onSave)="onSave()"
                    (back)="selectedItem.set(undefined)">
                </spike-order-page>
            }
        </div>

    </div>
</div>